import { forwardRef, ReactNode } from 'react';

type Props = {
  label: ReactNode;
  icon: React.ReactNode;
};

const VerticalNavigationDropdownOption = forwardRef<HTMLSpanElement, Props>(
  ({ label, icon, ...props }, ref) => {
    return (
      <span
        ref={ref}
        {...props}
        className="tw-flex tw-h-full tw-w-full tw-items-center tw-text-inherit tw-transition-all tw-duration-100 tw-ease-in-out"
      >
        <span className="tw-flex tw-items-center tw-justify-center tw-text-grayscale-100">
          {icon}
        </span>
        <span className="tw-ml-3 tw-flex tw-items-center tw-text-md tw-font-regular tw-text-inherit">
          {label}
        </span>
      </span>
    );
  },
);

export default VerticalNavigationDropdownOption;
